export default function _of(x) {
  return [x];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_of.js
// module id = 654
// module chunks = 0